<template>
    <RedesignBaseDataLoadChart
        :data="data"
        :data-processor="processData"
    />
</template>

<script lang="ts" setup>
import { ComposeOption } from 'echarts/core'
import {
    BarSeriesOption,
    LineSeriesOption,
} from 'echarts/charts'
import {
    TitleComponentOption,
    TooltipComponentOption,
    LegendComponentOption,
    GridComponentOption,
} from 'echarts/components'
import { WidgetExtended } from '@/types/dashboard'

import RedesignBaseDataLoadChart from '@/components/RedesignComponents/Charts/RedesignBaseDataLoadChart.vue'

/* Types */
type ECOption = ComposeOption<
    | BarSeriesOption
    | LineSeriesOption
    | TitleComponentOption
    | TooltipComponentOption
    | LegendComponentOption
    | GridComponentOption
>

/* Props */
defineProps<{
    data: WidgetExtended
}>()

/* Methods */
function processData (options: unknown): ECOption {
    return {
        title: {
            text: 'Bar and Line Chart Example',
        },
        tooltip: {
            trigger: 'axis',
        },
        legend: {
            data: [ 'Sales', 'Growth' ],
        },
        xAxis: {
            type: 'category',
            data: [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul' ],
        },
        yAxis: [
            {
                type: 'value',
                name: 'Sales',
            },
            {
                type: 'value',
                name: 'Growth (%)',
                position: 'right',
            },
        ],
        series: [
            {
                name: 'Sales',
                type: 'bar',
                data: [ 500, 700, 900, 800, 1200, 1500, 1700 ],
            },
            {
                name: 'Sales',
                type: 'bar',
                data: [ 100, 2700, 900, 800, 1200, 1500, 1700 ],
            },
            {
                name: 'Growth',
                type: 'line',
                yAxisIndex: 1,
                data: [ 5, 7, 9, 8, 12, 15, 17 ],
            },
            {
                name: 'Growth',
                type: 'line',
                yAxisIndex: 1,
                data: [ 12, 7, 9, 8, 2, 15, 17 ],
            },
        ],
    }
}
</script>
